export const attributeAsNumberIfExists = <T>(
  element: Element,
  attributeName: string,
  defaultValue: T
) => {
  if (element.hasAttribute(attributeName)) {
    const value = element.getAttribute(attributeName);
    if (value !== null) {
      return parseFloat(value);
    }
  }
  return defaultValue;
};
